import { Plugin } from 'vue';
import IdeoAccordion from './accordion/IdeoAccordion.vue';
import IdeoAccordionItem from './accordion/IdeoAccordionItem.vue';
import IdeoAlert from './alert/IdeoAlert.vue';
import IdeoAutocomplete from './autocomplete/IdeoAutocomplete.vue';
import IdeoButton from './button/IdeoButton.vue';
import IdeoButtonGroup from './button/IdeoButtonGroup.vue';
import IdeoMultiselect from './form-multiselect/IdeoMultiselect.vue';
import IdeoCollapse from './collapse/IdeoCollapse.vue';
import IdeoTime from './datetime/IdeoTime.vue';
import DateTimeButton from './datetime/DateTimeButton.vue';
import IdeoColor from './color/IdeoColor.vue';
import IdeoComboBox from './combobox/IdeoComboBox.vue';
import IdeoDateTimeNew from './datetime/IdeoDateTimeNew.vue';
import IdeoDropdown from './dropdown/IdeoDropdown.vue';
import IdeoDropdownDivider from './dropdown/IdeoDropdownDivider.vue';
import IdeoDropdownHeader from './dropdown/IdeoDropdownHeader.vue';
import IdeoDropdownItem from './dropdown/IdeoDropdownItem.vue';
import IdeoDropdownItemButton from './dropdown/IdeoDropdownItemButton.vue';
import IdeoDropdownText from './dropdown/IdeoDropdownText.vue';
import IdeoForm from './form/IdeoForm.vue';
import IdeoFormCheckbox from './form-checkbox/IdeoFormCheckbox.vue';
import IdeoFormCheckboxGroup from './form-checkbox/IdeoFormCheckboxGroup.vue';
import IdeoFormGroup from './form-group/IdeoFormGroup.vue';
import IdeoFormInput from './form-input/IdeoFormInput.vue';
import IdeoFormNumber from './form-number/IdeoFormNumber.vue';
import IdeoFormMultiselect from './form-multiselect/IdeoFormMultiselect.vue';
import IdeoFormRadio from './form-radio/IdeoFormRadio.vue';
import IdeoFormRadioGroup from './form-radio/IdeoFormRadioGroup.vue';
import IdeoFormSelect from './form-select/IdeoFormSelect.vue';
import IdeoFormSelectOption from './form-select/IdeoFormSelectOption.vue';
import IdeoFormSelectOptionGroup from './form-select/IdeoFormSelectOptionGroup.vue';
import IdeoFormTreeSelect from './form-tree-select/IdeoFormTreeSelect.vue';
import IdeoFormTextarea from './form-textarea/IdeoFormTextarea.vue';
import IdeoFormLocalize from './form-localize/IdeoFormLocalize.vue';
import IdeoFormToggler from './form-toggler/IdeoFormToggler.vue';
import IdeoImage from './image/IdeoImage.vue';
import IdeoInputGroup from './input-group/IdeoInputGroup.vue';
import IdeoInputGroupText from './input-group/IdeoInputGroupText.vue';
import IdeoModal from './modal/IdeoModal.vue';
import IdeoPanel from './panel/IdeoPanel.vue';
import IdeoPopover from './popover/IdeoPopover.vue';
import IdeoTabs from './tabs/IdeoTabs.vue';
import IdeoTab from './tabs/IdeoTab.vue';
import IdeoTabStrip from './tabs/IdeoTabStrip.vue';
import IdeoTree from './tree/IdeoTree.vue';
import IdeoTreePrime from './tree/IdeoTreePrime.vue';
import IdeoTreeNode from './tree/IdeoTreeNode.vue';
import IdeoTreeNodes from './tree/IdeoTreeNodes.vue';
import IdeoTooltip from './tooltip/IdeoTooltip.vue';
import WeightRangeFilter from '@/components/customFilters/WeightRangeFilter.vue';
import NumbersRangeFilter from '@/components/customFilters/NumbersRangeFilter.vue';
import LabeledFormInput from '@/components/bootstrap/form-input/LabeledFormInput.vue';
import LabeledFormTextarea from '@/components/bootstrap/form-textarea/LabeledFormTextarea.vue';
import IdeoExtendedList from './extended-list/IdeoExtendedList.vue';
import RowCodeRangeFilter from '@/components/customFilters/RowCodeRangeFilter.vue';
import DocumentPriorityFilter from '@/components/customFilters/DocumentPriorityFilter.vue';


const IdeoPlugin: Plugin =
{
    install(app, options)
    {
        app.component('IdeoAccordion', IdeoAccordion);
        app.component('IdeoAccordionItem', IdeoAccordionItem);
        app.component('IdeoAlert', IdeoAlert);
        app.component('IdeoAutocomplete', IdeoAutocomplete);
        app.component('IdeoMultiselect', IdeoMultiselect);
        app.component('IdeoButton', IdeoButton);
        app.component('IdeoButtonGroup', IdeoButtonGroup);
        app.component('IdeoCollapse', IdeoCollapse);
        app.component('IdeoColor', IdeoColor);
        app.component('IdeoComboBox', IdeoComboBox);
        app.component('IdeoDatetime', IdeoDateTimeNew);
        app.component('IdeoTime', IdeoTime);
        app.component('DateTimeButton', DateTimeButton);
        app.component('IdeoDropdown', IdeoDropdown);
        app.component('IdeoDropdownDivider', IdeoDropdownDivider);
        app.component('IdeoDropdownHeader', IdeoDropdownHeader);
        app.component('IdeoDropdownItem', IdeoDropdownItem);
        app.component('IdeoDropdownItemButton', IdeoDropdownItemButton);
        app.component('IdeoDropdownText', IdeoDropdownText);
        app.component('IdeoForm', IdeoForm);
        app.component('IdeoFormCheckbox', IdeoFormCheckbox);
        app.component('IdeoFormCheckboxGroup', IdeoFormCheckboxGroup);
        app.component('IdeoFormGroup', IdeoFormGroup);
        app.component('IdeoFormInput', IdeoFormInput);
        app.component('IdeoFormNumber', IdeoFormNumber);
        app.component('IdeoFormMultiselect', IdeoFormMultiselect);
        app.component('IdeoFormRadio', IdeoFormRadio);
        app.component('IdeoFormRadioGroup', IdeoFormRadioGroup);
        app.component('IdeoFormSelect', IdeoFormSelect);
        app.component('IdeoFormSelectOption', IdeoFormSelectOption);
        app.component('IdeoFormSelectOptionGroup', IdeoFormSelectOptionGroup);
        app.component('IdeoFormTreeSelect', IdeoFormTreeSelect);
        app.component('IdeoFormTextarea', IdeoFormTextarea);
        app.component('IdeoFormLocalize', IdeoFormLocalize);
        app.component('IdeoFormToggler', IdeoFormToggler);
        app.component('IdeoImg', IdeoImage);
        app.component('IdeoInputGroup', IdeoInputGroup);
        app.component('IdeoInputGroupText', IdeoInputGroupText);
        app.component('IdeoModal', IdeoModal);
        app.component('IdeoPanel', IdeoPanel);
        app.component('IdeoPopover', IdeoPopover);
        app.component('IdeoTabs', IdeoTabs);
        app.component('IdeoTab', IdeoTab);
        app.component('IdeoTabStrip', IdeoTabStrip);
        app.component('IdeoTree', IdeoTree);
        app.component('IdeoTreePrime', IdeoTreePrime);
        app.component('IdeoTreeNode', IdeoTreeNode);
        app.component('IdeoTreeNodes', IdeoTreeNodes);
        app.component('IdeoTooltip', IdeoTooltip);
        app.component('WeightRangeFilter', WeightRangeFilter);
        app.component('NumbersRangeFilter', NumbersRangeFilter);
        app.component('LabeledFormInput', LabeledFormInput);
        app.component('LabeledFormTextarea', LabeledFormTextarea);
        app.component('IdeoExtendedList', IdeoExtendedList);
        app.component('RowCodeRangeFilter', RowCodeRangeFilter);
        app.component('DocumentPriorityFilter', DocumentPriorityFilter);
    }
};

export default IdeoPlugin;
